var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

    var initializeBlock = function ($block) {

        
        $('.block-slider__slider').each(function () {
            var blockId = $(this).closest('.block-slider').attr('id');

            var autoplay = $(this).data('autoplay')
            var autoplayTime = $(this).data('time') * 1000

            autoplayOption = {
                delay: 9999999
            }
            if (autoplay == 1) {
                autoplayOption = {
                    delay: autoplayTime
                }
            }
            
            var swiperInit= new Swiper(this, {
                slidesPerView: 1,
                autoHeight: true,
                loop: false,
                autoplay: autoplayOption,
                navigation: {
                    prevEl: '#' + blockId + ' .block-slider__nav-prev',
                    nextEl: '#' + blockId + ' .block-slider__nav-next'
            }});

            swiperInit.on('slideChange', function (swiper) {
                sliderChange(blockId, swiper)
            });

            function sliderChange(blockId, swiper) {
                //let id = $('#' + blockId + ' .swiper-slide-active').data('id');
            }

        })

    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
     window.acf.addAction('render_block_preview/type=slider', initializeBlock);
    }
});
